import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MyOutstandingAmountService } from '@pg-app/client/client-dashboard/components/my-outstanding-amount/my-outstanding-amount.service';
import { ClientOutstandingTradesComponent } from '@pg-app/client/client-dashboard/components/tables/client-outstanding-trades/client-outstanding-trades.component';
import { UtilityService } from '@nttp/common-service/utility-service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'np-my-outstanding-amount',
  templateUrl: './my-outstanding-amount.component.html',
  styleUrls: ['./my-outstanding-amount.component.scss']
})
export class MyOutstandingAmountComponent implements OnInit {
  data = [];
  originalData = [];
  noPaddingRight = false;
  sortCurrency = null;
  sortAmount = null;
  todayOutstanding: FormGroup;
  destroy$ = new Subject<boolean>();
  isLoading = true;
  constructor(
    private dialog: MatDialog,
    private myOutstandingAmountService: MyOutstandingAmountService,
    public utiliService: UtilityService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.todayOutstanding = this.fb.group({
      currency: [''],
      amount: [''],
    });

    this.getData();

    this.todayOutstanding.get('currency').valueChanges.pipe(takeUntil(this.destroy$), debounceTime(350)).subscribe(value => {
      this.filterValue('currencyCode', value);
    });
    this.todayOutstanding.get('amount').valueChanges.pipe(takeUntil(this.destroy$), debounceTime(350)).subscribe(value => {
      this.filterValue('amount', value);
    });
  }

  filterValue(type, searchValue) {
    if (!searchValue) {
      this.data = this.originalData;
    } else {
      const value = searchValue.toLowerCase();
      if (type === 'amount') {
        this.data = this.originalData.filter(item => item.amount.toFixed(2).indexOf(searchValue.toString()) !== -1);
      } else {
        this.data = this.originalData.filter(item => item.currencyCode.toLowerCase().indexOf(value) !== -1);
      }
    }
  }

  sort(type) {
    if (type === 'currency') {
      this.sortCurrency = this.sortCurrency === 'asc' ? 'desc' : 'asc';
      this.sortAmount = '';
      this.sortData(this.sortCurrency, 'currencyCode');
    } else {
      this.sortAmount = this.sortAmount === 'asc' ? 'desc' : 'asc';
      this.sortCurrency = '';
      this.sortData(this.sortAmount, 'amount');
    }
  }

  sortData(sortType, itemType) {
    if (sortType === 'asc') {
      this.data.sort((previous, next) => {
        return previous[itemType] > next[itemType] ? 1 :
          previous[itemType] < next[itemType] ? -1 : 0;
      });
    } else {
      this.data.sort((previous, next) => {
        return previous[itemType] > next[itemType] ? -1 :
          previous[itemType] < next[itemType] ? 1 : 0;
      });
    }
  }

  getData() {
    const params = {
      pageSize: 1,
      pageIndex: 1,
      sortName: null
    };
    this.myOutstandingAmountService.getOutstandingAmount(params).subscribe(
      data => {
        this.originalData = data;
        this.data = data;
        this.isLoading = false;
      },
    );
  }

  public getClientOutstandingTrade(item) {
    this.dialog.open(ClientOutstandingTradesComponent, {
      data: {
        currencyId: item.currencyId
      }
    });
  }

  onDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
